import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import ProductPage from "@/pages/product/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/en/" replace />,
  },
  {
    path: "/en/",
    element: <Home />,
  },
  {
    path: "/fr/",
    element: <Home />,
  },
  {
    path: "/da/",
    element: <Home />,
  },
  {
    path: "/de/",
    element: <Home />,
  },
  {
    path: "/en/allchinabuy-spreadsheet/",
    element: <ArticlePage />,
  },
  {
    path: "/fr/allchinabuy-spreadsheet/",
    element: <ArticlePage />,
  },
  {
    path: "/da/allchinabuy-spreadsheet/",
    element: <ArticlePage />,
  },
  {
    path: "/de/allchinabuy-spreadsheet/",
    element: <ArticlePage />,
  },
  {
    path: "/en/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/fr/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/da/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/de/product/:id",
    element: <ProductPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;